//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const bodyAreas = useStore((state) => state.bodyAreas);
  const setBodyAreas = useStore((state) => state.setBodyAreas);

  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setBodyAreas(value);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.bodyAreas.title')}</Title>
        <Text className='description' size='m' medium style={{padding: '0px'}}>
          {t('onboarding.bodyAreas.subtitle')}
        </Text>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={bodyAreas} onChange={handleChange}>
          <MultiOption value={'arms'}>
            <span>💪</span>
            {t('onboarding.bodyAreas.options.arms')}
          </MultiOption>
          <MultiOption value={'legs'}>
            <span>🦵</span>
            {t('onboarding.bodyAreas.options.legs')}
          </MultiOption>
          <MultiOption value={'butt'}>
            <span>🍑</span>
            {t('onboarding.bodyAreas.options.butt')}
          </MultiOption>
          <MultiOption value={'belly'}>
            <span>🩰</span>
            {t('onboarding.bodyAreas.options.belly')}
          </MultiOption>
          <MultiOption value={'chest'}>
            <span>🫁</span>
            {t('onboarding.bodyAreas.options.chest')}
          </MultiOption>
          <MultiOption value={'back'}>
            <span>🦴</span>
            {t('onboarding.bodyAreas.options.back')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.bodyAreas.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'body-areas',
              answer: bodyAreas.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
